/**
 * Format and pass decoded label aliases values (btnLabel) and updated classes (btnClasses) to
 * correctly display VehicleCTAs in ws-vehicle-toolbar.
 *
 * @param {Array} ctasArr - The vehicle CTA buttons array from the vehicle data.
 * @param {object} labels - The labels object returned from useLabels() hook.
 * @param {boolean} isMobile - The device type.
 */

export const getVehicleToolbarCTAs = (ctasArr, labels, isMobile) => {
	if (!ctasArr?.length) {
		return [];
	}

	return ctasArr.map((cta) => {
		const btnClasses = cta?.btnClasses?.replace(
			'btn-default',
			'btn-primary'
		);
		// mb-3 is added by ButtonContainer, need mt-3 to center for now
		const additionalClasses = isMobile ? 'btn-xs mt-3' : 'btn-sm mt-3';

		return {
			...cta,
			btnClasses: `${btnClasses} ${additionalClasses}`,
			btnLabel: labels?.get(cta?.btnLabel)
		};
	});
};
